import { Navigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * dev 環境限定で、管理者以外がログインした際に表示するページ。
 * この環境（dev.vrmahub.com）は管理者のみが利用でき、一般ユーザーは
 * 本番サイト（vrmahub.com）を利用してもらう案内をする。
 */
export default function NoAccess() {
  const { user, logout } = useAuth();

  // ゲート無効ビルド（本番）ではこの画面に意味がないのでトップへ逃がす。
  if (import.meta.env.VITE_REQUIRE_LOGIN !== 'true') return <Navigate to="/" replace />;

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-card__title">アクセスできません</h1>
        <p className="auth-card__lead">
          この開発環境は管理者のみ利用できます。
          {user?.email && (
            <>
              <br />
              現在 <strong>{user.email}</strong> としてログインしています。
            </>
          )}
          <br />
          管理者アカウントをお持ちの場合は、ログアウトして入り直してください。
        </p>

        <button type="button" className="btn btn--primary" onClick={logout}>
          ログアウト
        </button>

        <p className="auth-card__lead">
          一般のご利用は本番サイト（
          <a href="https://vrmahub.com">https://vrmahub.com</a>
          ）をご利用ください。どなたでもご利用いただけます。
        </p>
      </div>
    </div>
  );
}
